import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
  // 统一使用完整的URL配置
  baseURL: process.env.VUE_APP_BASE_HOST,
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 如果是 blob 类型（文件下载），直接返回
    if (response.data instanceof Blob) {
      return response.data
    }
    return response.data
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

export default service
